// AB   MK-018
// Progressive enhancement for Before & After slider
document.addEventListener('DOMContentLoaded', () => {
  const sectionRoot = document.querySelector('.before-and-after-section');
  if (!sectionRoot) return;

  // Handle video thumbnail functionality
  function initVideoThumbnails() {
    const videoThumbnails = sectionRoot.querySelectorAll('.video-thumbnail-wrapper');
    
    videoThumbnails.forEach(wrapper => {
      const playButton = wrapper.querySelector('.video-play-button');
      const thumbnail = wrapper.querySelector('.video-thumbnail');
      const video = wrapper.querySelector('.testimonial-video');
      
      if (!video) return;
      
      // Click handler for thumbnail
      const playVideo = () => {
        // Hide thumbnail and play button (if it exists)
        if (thumbnail) thumbnail.style.display = 'none';
        if (playButton) playButton.style.display = 'none';
        
        // Show and play video with audio enabled
        video.style.display = 'block';
        video.muted = false;
        video.play().catch(e => {
          // Video playback failed - silently handle error
        });
        
        // Mark wrapper as playing
        wrapper.classList.add('playing');
      };
      
      // Add click listeners
      if (playButton) {
        playButton.addEventListener('click', playVideo);
      }
      if (thumbnail) {
        thumbnail.addEventListener('click', playVideo);
        thumbnail.style.cursor = 'pointer';
      }
      
      // Reset when video ends
      video.addEventListener('ended', () => {
        if (thumbnail) thumbnail.style.display = 'block';
        if (playButton) {
          playButton.style.display = 'flex';
        }
        video.style.display = 'none';
        wrapper.classList.remove('playing');
      });
    });
  }

  // Initialize video thumbnails
  initVideoThumbnails();

  const swiperContainer = sectionRoot.querySelector('.before-and-after-slider');
  if (!swiperContainer || typeof Swiper === 'undefined') return;

  // Initialize Swiper only for mobile (when slider is visible)
  let swiper = null;

  function initSwiper() {
    // Check if slider is visible (mobile)
    const isSliderVisible = window.getComputedStyle(swiperContainer).display !== 'none';
    
    if (isSliderVisible && !swiper) {
      swiper = new Swiper(swiperContainer, {
        // Slider settings
        slidesPerView: 1,
        spaceBetween: 100,
        centeredSlides: false,
        loop: true,
        
        // Navigation arrows
        navigation: {
          nextEl: sectionRoot.querySelector('.swiper-button-next'),
          prevEl: sectionRoot.querySelector('.swiper-button-prev'),
        },
        
        // Pagination bullets
        pagination: {
          el: sectionRoot.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
          dynamicMainBullets: 5,
        },
        
        // Touch/swipe settings
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          paginationBulletMessage: 'Go to testimonial {{index}}',
        },
        
        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        
        // Effects
        effect: 'slide',
        speed: 300,
        
        // Lazy loading for images/videos
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 1,
        },
        
        // After init callback to add custom icons
        on: {
          init: function() {
            // Add custom SVG icons to navigation buttons after Swiper is initialized
            const nextButton = sectionRoot.querySelector('.swiper-button-next');
            const prevButton = sectionRoot.querySelector('.swiper-button-prev');
            const arrowTemplate = document.getElementById('arrow-svg-template');
            
            if (arrowTemplate && nextButton && prevButton) {
              const arrowSvg = arrowTemplate.innerHTML;
              nextButton.innerHTML = arrowSvg;
              prevButton.innerHTML = arrowSvg;
            }
          }
        }
      });
    } else if (!isSliderVisible && swiper) {
      // Destroy swiper if it exists but slider is not visible (desktop)
      swiper.destroy(true, true);
      swiper = null;
    }
  }

  // Initialize on load
  initSwiper();

  // Re-initialize on window resize to handle mobile/desktop transitions
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      initSwiper();
      // Re-initialize video thumbnails after potential DOM changes
      initVideoThumbnails();
    }, 150);
  });

  // Handle video autoplay when slide becomes active
  if (swiper) {
    swiper.on('slideChange', function () {
      const activeSlide = this.slides[this.activeIndex];
      const video = activeSlide.querySelector('video');
      
      // Pause all videos first
      sectionRoot.querySelectorAll('video').forEach(v => {
        v.pause();
      });
      
      // Play video in active slide if it exists and has autoplay
      if (video && video.hasAttribute('autoplay')) {
        video.play().catch(e => {
          // Ignore autoplay failures (browser policy)
        });
      }
    });
  }

  // Handle intersection observer for performance
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Section is visible, ensure swiper is active if needed
          initSwiper();
        } else {
          // Section is not visible, pause all videos to save resources
          sectionRoot.querySelectorAll('video').forEach(video => {
            video.pause();
          });
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '50px'
    });

    observer.observe(sectionRoot);
  }
});